import React, { } from 'react';
import COLOR from "../Styles/Colors";
import { NeutralColors } from '@uifabric/fluent-theme/lib/fluent/FluentColors';
import { TooltipHost, TooltipBase, IconButton, PrimaryButton, CommandBarButton, DirectionalHint, getTheme, Stack, Spinner, Icon, Text, Tooltip } from '@fluentui/react';

const theme = getTheme();

export const BaseButton = props => {
    return (
        <TooltipHost
            content={props.tooltip}
            styles={{ root: { display: 'inline-block' } }}
            directionalHint={DirectionalHint.bottomCenter}
        >
            <PrimaryButton text={props.title} allowDisabledFocus styles={styles.addButton} split />
        </TooltipHost>
    )
};

export const CommandButton = props => {
    return (
        <TooltipHost
            content={props.tooltip}
            styles={{ root: { display: 'inline-block' } }}
            directionalHint={DirectionalHint.bottomCenter}
        >
            <CommandBarButton iconProps={{ iconName: props.iconName }} text={props.title} styles={styles.processButton} />
        </TooltipHost>
    )
};

const widthScreenScroll = window.screen.width;

export const AppButton = props => {
    return (
        <TooltipHost
            content={props.tooltip}
            styles={{ root: { display: 'inline-block' } }}

        >
            <IconButton
                iconProps={{ iconName: props.iconName }}
                styles={styles.iconButton(props.active)}
                onClick={props.onClick}
            />
            {props.title}
        </TooltipHost>
    )
};

export const ActionButton = props => {
    return (
        <TooltipHost
            content={props.tooltip}
        >
            <CommandBarButton
                width={props.width || '100px'}
                iconProps={{ iconName: props.iconName }}
                styles={styles.iconButton(props.active, props.checkQuyHoach, widthScreenScroll < 500)}
                onClick={props.onClick}
                className={`${props.active === true ? 'chosen' : 'nochose'} `}
                checked={props.active}
                text={props.text}
                disabled={props.disabled}
            >
            </CommandBarButton>
        </TooltipHost>
    )
};

export const HorizontalDivider = () => {
    return (
        <div style={styles.horizontalDivider} />
    )
};

export const VerticalDivider = () => {
    return (
        <div style={styles.verticalDivider} />
    )
};

export const MenuItem = props => {
    return (
        <CommandBarButton
            className='col'
            iconProps={{ iconName: props.iconName }}
            text={props.title}
            styles={styles.menuItem}
            checked={props.checked}
        />
    )
};

export const Loading = () => {
    return (
        <Stack styles={styles.loadingContainer}>
            <Spinner label="Đang tải..." />
        </Stack>
    )
}

export const Error = ({ message }) => {
    return (
        <Stack styles={styles.loadingContainer}>
            <Icon iconName={'Error'} styles={styles.errorIcon} />
            <Text variant={'medium'}>{message}</Text>
        </Stack>
    )
}


const styles = {
    addButton: {
        menuIcon: {

        },
        label: {
            fontSize: 12
        }
    },
    processButton: {
        root: {
            height: 32,
            backgroundColor: COLOR.transparent,
            marginRight: 3
        },
        label: {
            fontSize: 12,
            color: COLOR.blue
        },
        icon: {
            fontSize: 16
        }
    },
    // checkQuyHoach sử dụng active nút vẽ quy hoạch 
    iconButton: (active, checkQuyHoach, isSmall) => ({
        root: {
            minHeight: isSmall ? 50 : 32,
            //width: 48,
            borderRadius: 7,
            backgroundColor: COLOR.white,
            marginRight: 10,
            border: `1px solid #0078d4`,
            padding: 5
        },

        // rootHovered: {
        //     backgroundColor: COLOR.darkBlue
        // },
        // rootPressed: {
        //     backgroundColor: COLOR.darkBlue
        // },
        icon: {
            color: COLOR.white,
            fontSize: 16
        },
        label: {
            fontWeight: checkQuyHoach ? 'bold' : 'unset',
            color: '#0078d4'
        },
        iconHovered: {
            color: checkQuyHoach ? COLOR.blue : COLOR.white,
        },
        iconPressed: {
            opacity: .6
        }
    }),
    horizontalDivider: {
        height: 1,
        width: '100%',
        backgroundColor: COLOR.border
    },
    verticalDivider: {
        width: 1,
        height: '100%',
        backgroundColor: COLOR.border
    },
    menuItem: {
        root: {
            height: 36,
            backgroundColor: COLOR.transparent,
            width: '100%'
        },
        label: {
            textAlign: 'left',
            marginLeft: 10,
            fontSize: 12
        },
        icon: {
            textAlign: 'center',
            color: theme.palette.themePrimary
        },
        rootChecked: {
            backgroundColor: theme.palette.themeLight
        },
        labelChecked: {
            color: theme.palette.themePrimary,
            fontWeight: '600'
        },
        rootCheckedHovered: {
            backgroundColor: theme.palette.themeLight
        },
        iconChecked: {
            color: theme.palette.themePrimary
        }
    },
    loadingContainer: {
        root: {
            flex: 1,
            justifyContent: 'center',
            alignItems: 'center',
            padding: '10px 30px'
        }
    },
    loadingSpin: {
        root: {
            padding: '10px 20px',
            border: '1px solid #eee'
        }
    },
    errorIcon: {
        root: {
            fontSize: 80,
            color: NeutralColors.gray90
        }
    }
};
